export const TRAVEL_PATTERN_DAY_SHORT_CODES = {
    Mon: 'm',
    Tue: 'tu',
    Wed: 'w',
    Thu: 'th',
    Fri: 'f',
    Sat: 'sa',
    Sun: 'su'
};

export const TRAVEL_PATTERN_DAY_NAMES = {
    m: 'Mon',
    tu: 'Tue',
    w: 'Wed',
    th: 'Thu',
    f: 'Fri',
    sa: 'Sat',
    su: 'Sun'
};

export const isAdhoc = ticket =>
    (ticket.type === 'return' && ticket.sub_type !== 'fixed') ||
    ['single', 'week', '4_week'].includes(ticket.type);

export const getCurrencySymbol = currency => {
    if (currency === 'eur') {
        return '€';
    }
    return '£';
};

export const parseTravelPattern = travelPattern => {
    if (!travelPattern) {
        return '';
    }

    const travelPatternArr = travelPattern.split('#');

    return travelPatternArr
        .map(item => {
            if (item === 'm') {
                return 'Mon';
            }

            if (item === 'tu') {
                return 'Tue';
            }

            if (item === 'w') {
                return 'Wed';
            }

            if (item === 'th') {
                return 'Thu';
            }

            if (item === 'f') {
                return 'Fri';
            }

            if (item === 'sa') {
                return 'Sat';
            }

            if (item === 'su') {
                return 'Sun';
            }

            return '';
        })
        .join('/');
};

export const getYearGroups = yearGroups => {
    const groups = [];
    const primaryGroups = ['reception', 1, 2, 3, 4, 5, 6];
    const secondaryGroups = [7, 8, 9, 10, 11];
    const sixthForm = [12, 13];

    if (!yearGroups) {
        return groups;
    }

    if (yearGroups.primary) {
        groups.push(...primaryGroups);
    }

    if (yearGroups.secondary) {
        groups.push(...secondaryGroups);
    }

    if (yearGroups.sixth_form) {
        groups.push(...sixthForm);
    }

    return groups;
};

export const getMinPrice = (ticket, service) => {
    if (
        ticket.pricing_model === 'Zonal' &&
        ticket.zone_prices &&
        service.zones
    ) {
        const validTicketZoneNames = Object.keys(ticket.zone_prices).filter(
            ticketZone =>
                service.zones.find(
                    serviceZone => serviceZone.name === ticketZone
                ) && ticket.zone_prices[ticketZone] > 0
        );

        const validTicketZonePrices = validTicketZoneNames.map(
            validZoneName => ticket.zone_prices[validZoneName]
        );

        const zonePrices = Object.values(validTicketZonePrices);
        const zoneMin = Math.min(...zonePrices).toFixed(2);
        return zoneMin;
    }

    return ticket.price;
};

export const hasValidZonePricing = (ticket, service) => {
    if (
        !service.zones ||
        !service.zones.length ||
        !ticket.zone_prices ||
        !Object.keys(ticket.zone_prices).length
    ) {
        return false;
    }

    const validTicketZones = Object.keys(ticket.zone_prices).filter(
        ticketZone =>
            service.zones.find(
                serviceZone => serviceZone.name === ticketZone
            ) && ticket.zone_prices[ticketZone] > 0
    );

    return validTicketZones.length > 0;
};

// Duplicated from formatters.js to avoid circular dependency.
export const formatPrice = (price, currency) => {
    const formattedPrice = Number(price);

    // eslint-disable-next-line no-restricted-globals
    if (isNaN(formattedPrice)) {
        return '';
    }

    return `${getCurrencySymbol(currency)}${Number(price).toFixed(2)}`;
};

export const getReadablePriceSummary = (
    { singles, returns },
    priceSingle,
    priceReturn,
    ticket,
    options = {}
) => {
    const shortened = options.shortened || false;
    let output = '';

    if (singles) {
        output += `${singles} ${
            shortened ? 'x' : 'single tickets at'
        } ${formatPrice(priceSingle, ticket.currency)}${
            shortened ? ' SGL' : ''
        }`;
    }

    if (singles && returns) {
        output += ' & ';
    }

    if (returns) {
        output += `${returns} ${
            shortened ? 'x' : ' return tickets at'
        } ${formatPrice(priceReturn, ticket.currency)}${
            shortened ? ' RTN' : ''
        }`;
    }

    return output;
};

export const calculateSelectPrice = (travelPattern, ticket, zone) => {
    const useZones =
        ticket.pricing_model === 'Zonal' && ticket.zone_prices && zone;

    const days = travelPattern.split('#').map(pat => pat.split('_'));

    const singlePrice = useZones ? ticket.zone_prices[zone] : ticket.price;
    const returnPrice = useZones
        ? ticket.zone_return_prices[zone]
        : ticket.return_price;

    return days
        .reduce((acc, [day, amPm]) => {
            const dayKey = TRAVEL_PATTERN_DAY_NAMES[day].toLowerCase();
            const journeysOnDay = ticket.num_bookable_journeys[dayKey];
            const isReturn = !amPm;

            return acc + (isReturn ? returnPrice : singlePrice) * journeysOnDay;
        }, 0)
        .toFixed(2); // @NOTE: Needed in order to avoid return values like 524.4000000000001
};
